<template>
  <div>
    <h2 class="page-title">小课记录</h2>
    <el-card>
      <div class="filter-bar">
        <el-input v-model="keyword" placeholder="姓名 / 电话" clearable @keyup.enter.native="search" style="width:180px" />
        <el-date-picker v-model="startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" size="small" />
        <span>至</span>
        <el-date-picker v-model="endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" size="small" />
        <el-button type="primary" size="small" @click="search">搜索</el-button>
      </div>

      <el-table :data="records" v-loading="loading" border stripe class="desktop-table">
        <el-table-column prop="studentName" label="学员" width="100" />
        <el-table-column prop="hoursDeducted" label="小课" width="70" />
        <el-table-column label="扣大课" width="80">
          <template slot-scope="{ row }">
            <span v-if="row.exchangeGroupHours > 0">{{ row.exchangeGroupHours }}</span>
            <span v-else style="color:#C0C4CC">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="lessonTime" label="上课时间" min-width="160" />
        <el-table-column prop="remark" label="备注" min-width="120" />
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag v-if="row.recordStatus === 2" type="danger" size="small">欠费待缴</el-tag>
            <el-tag v-else-if="row.recordStatus === 3" type="warning" size="small">已补缴</el-tag>
            <el-tag v-else-if="row.exchangeGroupHours > 0" type="warning" size="small">大课抵</el-tag>
            <el-tag v-else type="success" size="small">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="canDelete" label="操作" width="80">
          <template slot-scope="{ row }">
            <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="mobile-list">
        <div v-for="row in records" :key="row.id" class="mobile-card">
          <div class="mobile-header">
            <span>{{ row.studentName }}</span>
            <span>-{{ row.hoursDeducted }}小课<span v-if="row.exchangeGroupHours > 0">（扣大课{{ row.exchangeGroupHours }}）</span></span>
          </div>
          <div class="mobile-time">{{ row.lessonTime }}</div>
          <div v-if="row.remark" class="mobile-remark">{{ row.remark }}</div>
          <el-button v-if="canDelete" size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
        </div>
      </div>

      <el-pagination
        style="margin-top: 16px"
        @current-change="p => { page = p; loadRecords(true) }"
        :current-page="page"
        :page-size="size"
        :total="total"
        layout="total, prev, pager, next"
      />
    </el-card>
  </div>
</template>

<script>
import { getPrivateRecords, deletePrivateRecord } from '../../api'

export default {
  name: 'PrivateRecords',
  data() {
    return {
      keyword: '', startDate: '', endDate: '',
      records: [], page: 1, size: 20, total: 0, loading: false
    }
  },
  computed: {
    canDelete() {
      return Number(localStorage.getItem('admin_role') || 1) !== 2
    }
  },
  mounted() { this.search() },
  methods: {
    search() {
      this.page = 1
      this.loadRecords(true)
    },
    async loadRecords(reset) {
      this.loading = true
      try {
        const res = await getPrivateRecords({
          page: this.page, size: this.size,
          keyword: this.keyword, startDate: this.startDate, endDate: this.endDate
        })
        this.records = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      } finally {
        this.loading = false
      }
    },
    handleDelete(row) {
      this.$confirm(`确定删除「${row.studentName}」${row.lessonTime} 的小课记录？`, '删除确认', { type: 'warning' })
        .then(async () => {
          await deletePrivateRecord(row.id)
          this.$message.success('已删除')
          this.search()
        }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-title { margin-bottom: 20px; }
.filter-bar { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 16px; }
.mobile-list { display: none; }
.mobile-card { border: 1px solid #eee; border-radius: 8px; padding: 12px; margin-bottom: 12px; }
.mobile-header { display: flex; justify-content: space-between; font-weight: bold; margin-bottom: 4px; }
.mobile-time { font-size: 13px; color: #999; margin-bottom: 8px; }
.mobile-remark { font-size: 13px; color: #666; margin-bottom: 8px; }
@media (max-width: 768px) {
  .desktop-table { display: none; }
  .mobile-list { display: block; }
  .filter-bar .el-input { width: 100% !important; }
}
</style>
